var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 49C43.6536 49 49.25 43.4036 49.25 36.5C49.25 29.5964 43.6536 24 36.75 24C29.8464 24 24.25 29.5964 24.25 36.5C24.25 43.4036 29.8464 49 36.75 49Z",
    fill: "#92D050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M36.25 61C50.0571 61 61.25 49.8071 61.25 36C61.25 22.1929 50.0571 11 36.25 11C22.4429 11 11.25 22.1929 11.25 36C11.25 49.8071 22.4429 61 36.25 61Z",
    fill: "#92D050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.17ad891cebc37a95a610607f3bdd1e08.svg";
export { ForwardRef as ReactComponent };